import BaseEntityService from 'vue-core/services/BaseEntityService';
import env from 'environment';

class ReportService
    extends BaseEntityService {
  constructor() {
    super({
      baseUrl: env.baseUrl + '/reports'
    });
  }

  test({ instance, file, progress }) {
    const url = this.baseUrl + '/test/upload';

    const success = ({ statusCode, data }) => {
      console.log('Upload success:', statusCode, data);
      return this.processTestFile({ filename: data, instance });
    }

    const error = ({ statusCode, data }) => {
      console.log('Upload error:', statusCode, data);
      return Promise.reject({ statusCode, data });
    }

    return this.upload({
      url,
      data: file,
      progress: progress,
      //timeout: this.config.upload.timeout,
    }).then(success, error);
  }

  processTestFile({ filename, instance }) {
    const url = this.baseUrl + '/test/process/' + filename;

    return this.post({
      url,
      data: instance
    });
  }
}

const service = new ReportService();

export default service;
